// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"bw","reportCardBox":"bw","report-img-wrap":"bx","reportImgWrap":"bx","report-title":"by","reportTitle":"by","report-date":"bz","reportDate":"bz"};